import _ from 'underscore';
import { datadogLogs } from '~/lib/datadog';

export default class HttpUtils {
  static rawApiCall = function (method, url, data, successCallback, errorCallback) {
    return $.ajax({
      url,
      type: method,
      data,
      contentType: false,
      processData: false,
      success: successCallback,
      error: errorCallback,
    });
  };

  /** Export to csv as a form post request so the browser triggers a download of the returned file */
  static exportCSV = function (params, url) {
    const csrf = $('meta[name="csrf-token"]').attr('content');
    const form = $('<form></form>').attr('action', url).attr('method', 'POST');
    for (const paramName in params) {
      form.append(
        $('<input></input>')
          .attr('type', 'hidden')
          .attr('name', paramName)
          .attr('value', JSON.stringify(params[paramName])),
      );
    }
    form.append($('<input></input>').attr('type', 'hidden').attr('name', 'authenticity_token').attr('value', csrf));
    form.appendTo('body').submit().remove();
  };

  /**
   * Given a baseUri and an object
   * of queryParams where each
   * key is a param name and the value
   * is the param value, returns the
   * full URI with parameters in query
   * string format
   *
   * @param {*} baseUri REQUIRED
   * @param {*} queryParams
   * @param {boolean} arrayEncoding
   * @param {boolean} skipUndefined
   * @returns
   */
  static buildUriWithQueryString = (
    baseUri,
    queryParams,
    arrayEncoding = false,
    skipUndefined = false,
    encodeQueryParams = false,
  ) => {
    const params = skipUndefined
      ? Object.fromEntries(Object.entries(queryParams).filter(([, value]) => value !== undefined))
      : queryParams;

    if (_.isEmpty(params)) {
      return baseUri;
    }
    const queryString = HttpUtils.buildQueryString(params, arrayEncoding, encodeQueryParams);

    return `${baseUri}?${queryString}`;
  };

  static buildQueryString = (queryParams, arrayEncoding = false, encodeQueryParams = false) => {
    if (_.isEmpty(queryParams)) {
      return '';
    }

    const queryString = Object.entries(queryParams)
      .map(([key, value]) => {
        if (value instanceof Array && arrayEncoding) {
          return value.map((v) => `${key}[]=${encodeQueryParams ? encodeURIComponent(v) : v}`).join('&');
        }
        return `${key}=${encodeQueryParams ? encodeURIComponent(value) : value}`;
      })
      .join('&');

    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (arrayEncoding && Array.isArray(value)) {
        value.forEach((v) => searchParams.append(`${key}[]`, v));
      } else {
        searchParams.append(key, value);
      }
    });

    if (queryString !== searchParams.toString()) {
      datadogLogs.logger.error(`Query strings to do match:`, {
        actual: searchParams.toString(),
        expected: queryString,
      });
    }

    return queryString;
  };
}
